module.exports = "pegasus/assets/theme3/small/1.jpg";